import { useCallback } from 'react';
import { Field, Form } from '@app/api';
import { FieldConfig, fieldConfigurations } from '../fieldConfigurations';

const emptyArray: any[] = [];
export const useGetFieldConfiguration = (
  form: Form | undefined,
  page: number,
) => {
  const fields = (form && form.fields) || emptyArray;
  const getFieldConfiguration = useCallback(
    (currentPage: number = page) => {
      const field = fields[currentPage] as Field | undefined;
      const fieldConfiguration = field
        ? (fieldConfigurations[field.type] as FieldConfig<typeof field>)
        : undefined;

      return { field, fieldConfiguration };
    },
    [page, fields],
  );

  return getFieldConfiguration;
};
